import { routeConstants, routeName } from '../../routes/route-constants';
import { openReportState } from 'app/area/favourite/constants';

export function toCodeSelectView(breadcrumbs: string): string {
  return `/select/codetableadministration${breadcrumbs}`;
}

export function toCaseView(caseNumber: number): string {
  return `/case/${caseNumber}`;
}

export function toCaseEdit(caseNumber: number, entityPath: string): string {
  return `/case/${caseNumber}${entityPath}/edit`;
}

export function toCaseDuplicate(caseNumber: number): string {
  return `/case/${caseNumber}/duplicate`;
}

export function toCreateCase(caseTypeId: number): string {
  return `/create/${caseTypeId}`;
}

export function toDraft(draftId: number, entityPath: string): string {
  return `/draft/${draftId}${entityPath}`;
}

export function toCaseListing(favouriteId: number): string {
  return `/${routeName.Favourite}/draft/${favouriteId}`;
}

export function toUpdateSavedReport(favouriteId: number): string {
  return `/${routeName.Favourite}/${favouriteId}/${openReportState.edit}`;
}

export function toSearchViewWithQuery(query: string): string {
  return `${routeConstants.createFavouriteDraft}?query=${encodeURIComponent(query)}`;
}

export function toDashboardView(dashboardType: number): string {
  return `/dashboard/${dashboardType}/favourite/draft`;
}

export function toSavedDashboard(favouriteId: number, dashboardType: number): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/${favouriteId}`;
}

export function toUpdateSavedDashboard(favouriteId: number, dashboardTypeId: number): string {
  return `/${routeName.Dashboard}/${dashboardTypeId}/${routeName.Favourite}/${favouriteId}/${openReportState.edit}`;
}

export function toDashboardDraftFavourite(favouriteId: number, dashboardType: number): string {
  return `/${routeName.Dashboard}/${dashboardType}/${routeName.Favourite}/draft/${favouriteId}`;
}

export function toBowtie(caseNumber: number): string {
  return `/bowtie/${caseNumber}`;
}

export function toCompanyReportDraftFavourite(favouriteId: number, companyReportId: number): string {
  return `/${routeName.CompanyReport}/${companyReportId}/${routeName.Favourite}/draft/${favouriteId}`;
}

export function toSavedCompanyReport(favouriteId: number, companyReportId: number): string {
  return `/${routeName.CompanyReport}/${companyReportId}/${routeName.Favourite}/${favouriteId}`;
}

export function toUpdateSavedCompanyReport(favouriteId: number, companyReportId: number): string {
  return `/${routeName.CompanyReport}/${companyReportId}/${routeName.Favourite}/${favouriteId}/${openReportState.edit}`;
}
